<template>
  <div class="user-view">
    <b-table
      :data="holidays"
      :loading="loading"
      hoverable
      @click="setChosenHoliday"
    >
      <b-table-column field="name" label="Navn" searchable v-slot="props">
        {{ props.row.name }}
      </b-table-column>

      <b-table-column field="date" label="Dato" searchable v-slot="props">
        {{ dateFormat(props.row.date) }}
      </b-table-column>

      <b-table-column field="state" label="Alle Fri" v-slot="props">
        <b-checkbox :disabled="true" :value="props.row.state === 1"></b-checkbox>
      </b-table-column>
    </b-table>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import ApiState from "../../enums/APISTATE";
import moment, { ISO_8601 } from "moment";

export default {
  name: "holiday-view",
  components: {},
  data: () => ({
  }),
  async mounted() {
    await this.getHolidays();
  },
  computed: {
    ...mapGetters("holidayStore", ["holidaysApiState", "holidays"]),
    loading() {
      return this.holidaysApiState !== ApiState.LOADED;
    },
  },
  methods: {
    ...mapActions("holidayStore", ["getHolidays", "setChosenHoliday"]),
    dateFormat(arg) {
      return moment(arg).format("YYYY-MM-DD");
    },
  },
};
</script>

<style lang="scss" scoped>
.users-view {
  .register-user {
    cursor: pointer;
    width: 100%;
  }
}

.table td {
  text-align: left !important;
}
</style>
